<template>
  <div
    :class="[
      'fddform-input',
      iconClass,
      { 'fddform-input-cha': clearable },
      { 'fddform-input-search': searchable },
      { 'fddform-input-number': showWordLimit }
    ]"
  >
    <template v-if="type !== 'textarea'">
      <input
        v-model.trim="model"
        :type="type"
        class="input"
        :class="inputClass"
        :disabled="disabled"
        :maxlength="maxLength"
        :placeholder="placeholder"
        @focus="handleFocus"
        @blur="handleBlur"
        @keypress="doEnter"
      />
      <label v-if="searchable" class="use-search fdd-ico-search" @click="handleSearch"></label>
      <label v-if="clearVisible" class="input-close use-close" @click="handleClear"></label>
    </template>
    <textarea v-else v-model="model" :maxlength="maxLength" :disabled="disabled" :placeholder="placeholder"></textarea>
    <label v-if="isWordLimitVisible" :class="numberClass" :style="clearVisible ? 'margin-right:20px;' : ''"
      >{{ textLength }}/{{ maxLength }}</label
    >
  </div>
</template>
<script>
  export default {
    name: 'FddInput',
    props: {
      placeholder: {
        type: String,
        default: ''
      },
      value: {
        type: [String, Number],
        default: ''
      },
      clearable: {
        type: Boolean,
        default: false
      },
      searchable: {
        type: Boolean,
        default: false
      },
      showWordLimit: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      maxLength: {
        type: [Number, String]
      },
      inputClass: {
        type: [Object, String, Array]
      }
    },
    data() {
      return {
        focus: false
      }
    },
    computed: {
      model: {
        set(val) {
          this.$emit('input', val)
        },
        get() {
          return this.value
        }
      },
      textLength() {
        return this.value ? this.value.length : 0
      },
      iconClass() {
        let classString = ''
        if (!this.clearable && this.searchable) {
          classString = 'fddform-input-cha-no'
        }
        return classString
      },
      numberClass() {
        return this.type === 'textarea' ? 'textarea-text' : 'input-number'
      },
      isWordLimitVisible() {
        return this.disabled ? false : this.showWordLimit
      },
      clearVisible() {
        return !!(this.clearable && this.value)
      }
    },
    methods: {
      doEnter(e) {
        //增加回车
        if (e.keyCode === 13) {
          this.handleSearch()
        }
      },
      handleSearch() {
        this.$emit('search', this.value)
      },
      handleClear() {
        this.$emit('input', '')
      },
      handleFocus(e) {
        this.focus = true
        this.$emit('focus', e)
      },
      handleBlur(e) {
        this.focus = false
        this.$emit('blur', e)
      }
    }
  }
</script>
